<template>
  <!-- <div class="confirm-order" :class="appUser.isNative?'':'hasUser'"> -->
  <div class="confirm-order">
    <!-- 菜单栏（内嵌App时隐藏） -->
    <app-header :title="title" class="header" need-confirm="need" back-type="back-app" />
    <template v-if="goods.goodsId">
      <!-- Card: 学生认证 -->
      <!-- <template v-if="preOrder.isNeedAuthentic">
        <CardAuthentication @sfzChange="sfzChange" @xszChange="xszChange" @agree="agree"/><margin-line />
      </template> -->
      <!-- Card: 选择地址 -->
      <div style="border-top: 1px solid #f2f2f2"></div>
      <template v-if="preOrder.isNeedAddress">
        <CardAddress />
        <margin-line />
      </template>
      <!-- Card: 商品信息 兼容积分抵扣 -->
      <CardGoods :fromIntegral="fromIntegral" />
      <margin-line />
      <!-- Card: 优惠券 -->
      <CardCoupons v-if="!fromIntegral" />
      <margin-line />
    </template>
    <template v-else>
      <!-- Card: 学生认证 -->
      <!-- <template v-if="preOrder.isNeedAuthentic">
        <CardAuthentication @sfzChange="sfzChange" @xszChange="xszChange" @agree="agree"/><margin-line />
      </template> -->
      <!-- Card: 选择地址 -->
      <template v-if="preOrder.isNeedAddress">
        <CardAddress />
        <margin-line />
      </template>
      <!-- Card: 商品信息 兼容积分抵扣 -->
      <CardGoodList
        v-for="item in preOrder.goodsInfoList"
        :goods="item"
        :key="item.goodsId"
        :fromIntegral="fromIntegral"
      />
      <margin-line />
      <!-- Card: 优惠券 -->
      <CardCoupons v-if="!fromIntegral" />
      <margin-line />
    </template>
    <!-- Card: 支付方式 -->
    <CardPaymethod v-if="!fromIntegral" ref="cardPaymethod" />
    <div class="flexbox integral_pay_info_box" v-if="fromIntegral">
      <div>实付</div>
      <div class="pay_num_box">{{ goods.creditVal }}{{ integralName }}</div>
    </div>
    <!--  专辑商品新增提醒文案 -->
    <!-- <div class="tip_box" v-if="goods.goodsType === '20001'">
      <div class="tip_name">*你将购买的商品为虚拟内容服务，购买后不支持退订、转让、退换，请斟酌确认。</div>
      <div class="tip_name">*购买后，可在【友邻少年APP-我的-已购】中查看。</div>
    </div> -->
    <!-- 登录用户 -->
    <!-- <div class="user_info" v-if="orderLog.length">{{ orderLog }}</div> -->
    <!-- 支付结果弹窗 -->
    <!-- <PayResultAlert ref="payAlert" :is-confirm-order="true" /> -->
    <!-- <margin-line /> -->
    <!-- 用户信息 -->
    <CardUser v-if="!appUser.isNative"></CardUser>
    <!-- 支付按钮 -->
    <form-button-buttom
      v-if="preOrder && !preOrder.isEmpty && !preOrderIsError"
      text="立即支付"
      size="normal"
      @click="createOrder()"
    >
      <template #label>
        <!-- 积分 -->
        <div class="pay-price-integral" v-if="fromIntegral">
          {{ goods.creditVal }}
          <span class="price-unit">{{ integralName }}</span>
        </div>
        <!-- 其它 -->
        <div class="pay-price" v-else>
          <span class="price-unit">¥</span>
          {{ orderAmount }}
        </div>
      </template>
    </form-button-buttom>
  </div>
</template>

<script>
import { MessageBox } from 'mint-ui'
import { Toast } from 'vant'
import { mapGetters } from 'vuex'
import Body from '@/mixins/body'
import CardAddress from './components/card-address'
import CardUser from './components/card-user'
import CardGoods from './components/card-goods'
import CardGoodList from './components/card-good-list'
import CardCoupons from './components/card-coupons'
import CardPaymethod from './components/card-paymethod'
// import CardAuthentication from './components/card-authentication'
// import PayResultAlert from './components/pay-result-alert'
import { appUser, throttle, goodTypeStr } from '@/utils'

import { Pay } from '@/utils/common/pay'
import { orderAmount } from './options' // 计算订单支付金额
import { saTrack } from '@/utils/common/shence'
import { getAccountId } from '@/utils/init/pubs'
import { getCookie } from '@/utils/common/cookie'
import { bindUserReferrer } from '@/utils/bindUserReferrer'

export default {
  name: 'ConfirmOrder',
  components: {
    CardAddress,
    CardGoods,
    CardCoupons,
    CardUser,
    CardPaymethod,
    CardGoodList

    // CardAuthentication  //2022-04-07
    //, PayResultAlert
  },
  mixins: [Body],
  data() {
    return {
      appUser,
      title: '确认订单',
      xszValue: '',
      sfzValue: '',
      agreeData: true,
      goodsIdList: [],
      pType: ''
    }
  },
  computed: {
    ...mapGetters('goods/vip', [
      // 限购规则
      'limitData',
      'commitmentObj'
    ]),
    ...mapGetters('args', ['shareCode', 'fromIntegral']),
    ...mapGetters('payment/order', [
      'preOrder', // 预付单
      'order', // 下单后的订单
      'orderLog',
      'paymethod', // 支付方式的选择
      'installment',
      'coupon',
      'openByStages',
      'showConfirm',
      'count',
      'ratio',
      'discountIntegralReal' // 抵扣积分数量
    ]),
    ...mapGetters('integral/index', ['integralName']),
    ...mapGetters('payment/address', ['address']),
    isSubvipGoods() {
      return parseInt(this.commitmentObj?.goodsId) > 0
    },
    preOrderIsError() {
      return this.preOrder.errorCode > 0 // 错误编码
    },
    // 积分最终抵扣金额
    discountPricefroIntegral() {
      return this.discountIntegralReal / this.ratio
    },
    // 商品 (isNeedAddress 实物商品需要地址信息)
    goods() {
      return this.preOrder.goodsInfo || {}
    },
    orderAmount,
    to() {
      return { name: 'goods' }
    },
    goodsId() {
      const { id } = this.$route.params
      if (this.$route.query.goodsIdList) {
        this.goodsIdList = this.$route.query.goodsIdList.split('-')
        this.ptype = this.$route.query.paytype
      }
      return parseInt(id)
    },
    // 是无限卡购买（VIP商品 & 权益类型无限）
    isVipForever() {
      const { goods } = this
      const { goodsType, equityType } = goods
      return goodsType === '50001' && equityType === 'forever'
    },
    // 是否是无限卡增订版
    isVipForeverIncrease() {
      const { goods } = this
      const { goodsType, equityType } = goods
      return goodsType === '50001' && equityType === 'renewal'
    },
    // 是否是无限卡增订版 的增订商品 比如1元续订
    isIncrease() {
      const { goods } = this
      const { goodsType, equityType } = goods
      return goodsType === '50001' && equityType === 'renewal_year'
    },
    // 减扣总金额
    discounts() {
      const discountList = this.preOrder.discountList || []
      let discounts = 0
      discountList.forEach(dis => {
        discounts += dis.realPayAmount
      })
      return discounts
    },
    wx_oauth() {
      return JSON.stringify(this.orderLog, 0, 2)
    },
    // 赠品中是否有实物商品 没用到
    noAddressText() {
      if (this.goods.goodsType !== '90001' && this.preOrder.isNeedAddress) {
        return '赠品中包含实物，请填写地址信息'
      } else {
        return null
      }
    }
  },
  activated() {
    // 需要切换购买的商品（导购页购买时已设置 preOrder，就不会触发了）
    console.log(this.$route.params, this.ptype, this.goodsIdList, '--------')
    const { goodsId } = this.preOrder.goodsInfo || {}
    if (this.ptype) {
      this.preCreate()
      return
    }
    if (goodsId && goodsId !== this.goodsId) {
      // console.log('商品更换', goodsId, this.goodsId)
      this.preCreate()
    }
  },
  beforeRouteLeave(to, from, next) {
    console.log('beforeRouteLeave', to, from, next)
    if (to.name === 'goods') {
      MessageBox.confirm('是否放弃本次付款', {
        cancelButtonText: '放弃',
        confirmButtonText: '继续支付'
      })
        .then(action => {
          if (action === 'confirm') {
            next(false)
          }
        })
        .catch(action => {
          if (action === 'cancel') {
            next()
          }
        })
    } else {
      next()
    }
  },
  mounted() {
    document.addEventListener('visibilitychange', this.hanldeVisiblityChange)
    const isIos = /ipad|iPhone|Mac/i.test(window.navigator.userAgent)
    if (isIos) {
      window.addEventListener('pageshow', this.showPage())
    }
  },
  destroyed() {
    document.removeEventListener('visibilitychange', this.hanldeVisiblityChange)
    document.removeEventListener('pageshow', this.showPage())
  },
  methods: {
    // 监听手机物理返回，然后跳转首页
    pushHistory() {
      const state = { title: '友邻少年', url: '#' }
      window.history.pushState(state, '友邻少年', '#')
    },
    hanldeVisiblityChange() {
      if (document.visibilityState === 'hidden') {
        console.info('当前页面不可见了')
      } else if (document.visibilityState === 'visible') {
        console.info('当前页面可见了', this.showConfirm)
        this.showPage()
      }
    },
    showPage() {
      let showConfirm = localStorage.getItem('showConfirm')
      console.info('page show', showConfirm, appUser.isBrowser || appUser.isNative)
      if (showConfirm) {
        // this.$store.commit('payment/order/setPopShow', false)

        localStorage.setItem('showConfirm', false)
        if (appUser.isBrowser) {
          const order = this.order
          console.log('info info ', JSON.parse(localStorage.getItem('USER-PAYMENT_ORDER') || '{}'))
          console.log('orderId=>', order, this.goodsId)
          MessageBox.confirm('请确认订单支付是否完成', {
            cancelButtonText: '没有',
            confirmButtonText: '完成'
          })
            .then(action => {
              order.goodsId = this.goodsId
              this.payOrderResult(order, { status: 'success' })
            })
            .catch(action => {
              location.reload
            })
        }
      }
    },
    // 初始化数据（登录成功）
    created_hasToken() {
      this.preCreate()
    },
    // 地址刷新
    activated_hasToken() {
      this.getAddress()
    },
    // 获取下单购买信息
    successStatus(status) {
      return status >= 1
    },
    failStatus(status) {
      return status === -1
    },
    buyNumber() {
      const { order } = this
      // 订单已经支付完成，跳转至成功失败页面
      if (order && order.payStatus) {
        const { status } = order.payStatus
        // 已经支付成功过了
        if (this.successStatus(status)) {
          this.payOrderResult(order, { status: 'success' })
          return true
        }
        if (this.failStatus(status)) {
          // this.payOrderResult(order, { status: 'fail' });
          return true
        }
      }
    },
    sfzChange(value) {
      console.log('身份证号是', value)
      this.sfzValue = value
    },
    xszChange(value) {
      console.log('学生证号是', value)
      this.xszValue = value
    },
    // 创建预付订单
    preCreate() {
      // 保险起见, 下单前 再校验一次绑定关系
      bindUserReferrer(this.$store, '下单')
      const { goodsId } = this
      const userId = appUser.userId
      const { limitData } = this

      // 切换预创建订单服务
      const preCreate = () => {
        let data = { goodsId, userId }
        if (this.ptype) {
          data.goodsIdList = this.goodsIdList.map(item => item * 1)
          delete data.goodsId
          return this.$store.dispatch('payment/order/preCreateGoodsPhysical', data)
        }
        const { hasLimit } = limitData || {}
        if (hasLimit) {
          Object.assign(data, limitData)
          return this.$store.dispatch('payment/order/preCreateByLimit', data)
        } else {
          if (this.preOrder.isNeedAuthentic) {
            data = { goodsId, num: 1 }
            return this.$store.dispatch('payment/order/preCreateMini', data)
          } else {
            return this.$store.dispatch('payment/order/preCreate', data)
          }
        }
      }

      const preOrder = preCreate()
      preOrder.catch(({ code, data }) => {
        // 用户已经具备该商品权益，无需购买商品
        if (code === 30010 || code === 30007) {
          // 此处代码解决 Safari浏览器中 H5支付完成之后 Safari浏览器会跳转到一个新的页面，那个页面里面拿不到order信息，也就没法拿到支付结果 此处从本地Storage中拿到订单信息
          const order = JSON.parse(localStorage.getItem('USER-PAYMENT_ORDER') || '{}')
          console.log('preOrder order', order)
          if (Object.keys(order).length != 0) {
            if (this.goodsId === order.order.goodsId) {
              this.payOrderResult(order.order, { status: 'success' })
            }
          } else {
            this.routeSuccess(data)
          }
        } else if (code === 30024 || code === 30008) {
          MessageBox.alert('部分商品售罄或下架，请重新选择商品', '').then(res => {
            localStorage.setItem('goods=physical', 'reset')
            this.$router.go(-1)
          })
          return
        } else if (code !== 0) {
          Toast({ message: '账户异常，请联系班主任。错误code=' + code, position: 'middle' })
        }
      })
    },
    // 创建订单
    createOrder: throttle(
      function () {
        // 检查支付选择
        if (!this.before_createOrder()) return
        const payType = this.paymethod == 1 ? 'WX' : 'ZFB'
        const userReferrer = getCookie('userReferrer')
        const {
          goodsId, // 商品、销售
          preOrder, // 预付单
          orderAmount: amount,
          discounts, // 支付金额、扣减
          address,
          coupon,
          installment, // 地址、优惠券、分期、支付类型
          discountIntegralReal,
          commitmentObj // 家庭卡参数
        } = this
        const { limitData } = this
        const { goodsTypeName, goodsName } = this.goods
        // 开始创建订单（检查微信、APP、H5三个环境）
        const { orderAmount, buyNum, isNeedAddress, isNeedAuthentic } = preOrder
        const { installmentId, useCoupon } = installment || {}
        // 检查分期是否可用优惠券
        const couponId = installmentId && !useCoupon ? null : coupon.id

        saTrack('buy_goods_click', {
          buy_type: goodTypeStr(goodsTypeName),
          goods_ID: goodsId,
          goods_name: goodsName,
          is_use_coupon: Boolean(couponId),
          is_instalments: Boolean(installmentId),
          pay_money: amount,
          userReferrer, // 分享人
          creditCount: discountIntegralReal
        })

        // 调用原生购买方法
        let source = 'APP'
        if (appUser.isWeixin) source = 'PUB'
        if (appUser.isBrowser) source = 'WEB'

        let data = {
          source,
          addressId: address.id,
          amount: amount * 1,
          discount: discounts,
          couponId: couponId,
          goodsId,
          installmentId: installmentId || 0,
          sellerCode: this.shareCode, // 分享者编码
          totalPrice: orderAmount,
          num: buyNum,
          userId: appUser.userId,
          openId: appUser.openId,
          userNote: '',
          payType: payType,
          userReferrer, // 分享人
          creditCount: discountIntegralReal,
          num: 1
        }
        console.log(data, 'data')
        if (!isNeedAddress) {
          // 该商品不需要地址
          data.addressId = ''
        }
        // 家庭卡参数
        if (this.isSubvipGoods) {
          const {
            areaCode: destCountryCode,
            signUrl: evidence3,
            commitmentUrl,
            receiverIdentity,
            idCardUrl2: evidence2,
            idCardUrl: evidence1,
            phone: destMobile
          } = commitmentObj
          data = Object.assign(data, {
            receiverIdentity,
            destCountryCode,
            evidence1,
            evidence2,
            evidence3,
            commitmentUrl,
            destMobile
          })
        }
        // 免费商品直接兑换
        const isGoodsRedeemed = order => {
          console.log(order, 'order478')
          if (order.goodsRedeemed) {
            order.goodsId = this.goodsId
            this.$store.commit('payment/order/setCurrentOrder', order)
            this.payOrderResult(order, { status: 'success' })
            return null
          }
          return order
        }
        // 使用支付数据进行支付
        const isOrderPackageAndPay = order => {
          console.log('order1', order)
          if (order) {
            if (order.payType === 'WX') {
              // 微信支付+积分商品下单
              this.payOrder(order)
              return null
            } else if (order.code === 0) {
              // 支付宝
              this.payOrder(order)
              return null
            } else {
              if (order.renewalInfo && order.renewalInfo.message) {
                Toast({
                  message: order.renewalInfo.message,
                  position: 'bottom'
                })
              } else {
                Toast({ message: '请检查订单', position: 'bottom' })
              }
            }
          }
          return order
        }

        // 切换创建订单服务
        const create = () => {
          const accountId = getAccountId()
          // console.log('accountId',accountId)
          if (accountId == 'ylyk_pub_old') {
            Toast({
              message: '公众号主体已经迁移，请点击右上角刷新重试。',
              position: 'center'
            })
            return
          }
          const { hasLimit } = limitData || {}
          if (this.ptype) {
            data.goodsIdList = this.goodsIdList
            delete data.goodsId
            return this.$store.dispatch('payment/order/createGoodsPhysical', data)
          }
          if (hasLimit) {
            Object.assign(data, limitData)
            return this.$store.dispatch('payment/order/createByLimit', data)
          } else {
            if (isNeedAuthentic) {
              data.idCard = this.sfzValue
              data.studentNo = this.xszValue
              data.num = 1
              if (!isNeedAddress) {
                // 该商品不需要地址
                data.addressId = ''
              }
              if (isNeedAuthentic) {
                // 该商品需要学生认证
                if (!this.agreeData) {
                  // 没同意用户协议
                  Toast({
                    message: '请阅读并同意《友邻少年用户许可协议和隐私政策议》',
                    position: 'center'
                  })
                  return
                }
                if (data.idCard === '') {
                  Toast({ message: '请输入身份证号', position: 'center' })
                } else if (data.studentNo === '') {
                  Toast({ message: '请输入学生证号', position: 'center' })
                } else if (data.idCard.length > 18) {
                  Toast({ message: '身份证号不正确', position: 'center' })
                } else if (data.studentNo.length > 30) {
                  Toast({ message: '学生证号不正确', position: 'center' })
                } else {
                  return this.$store.dispatch('payment/order/createMini', data)
                }
              } else {
                return this.$store.dispatch('payment/order/createMini', data)
              }
            } else {
              const path = this.fromIntegral ? 'payment/order/createIntegral' : 'payment/order/create'
              return this.$store.dispatch(path, data)
            }
          }
        }

        const createOrder = () => {
          create()
            .then(isGoodsRedeemed)
            .then(isOrderPackageAndPay)
            .catch(({ code }) => {
              // 【微信端】公众号支付缺少OpenId，线上存在时，帮用户退出登录
              if (code === 30020 && appUser.token) {
                appUser.resetToken()
                location.reload()
                history.back() // 返回导购页
              } else if (code == 30127 || code == 30011 || code == 30012) {
                history.back() // 返回导购页
              } else if (code === 30024 || code === 30008) {
                MessageBox.alert('部分商品售罄或下架，请重新选择商品', '').then(res => {
                  localStorage.setItem('goods=physical', 'reset')
                  this.$router.go(-1)
                })
                return
              }
            })
        }
        // 提示地址
        if (isNeedAddress) {
          console.log(this.goods.goodsLimitArea, 'goodsLimitArea')
          if (this.goods.goodsLimitArea && this.goods.goodsLimitArea.length) {
            let index = this.goods.goodsLimitArea.findIndex(item => item.cityCode === this.address.cityCode)
            console.log(index)
            if (index !== -1) {
              Toast({
                message: `该地区暂不支持发货，请重新选择地址\n如有疑问，请联系班主任`,
                position: 'center'
              })
              return
            }
          }
          const message = `<div class="message-address">
          联系人：${address.contactName} ${address.contactNo} <br/>
          地址：${address.mergeAreaDetail}</div>`
          MessageBox.confirm(message, {
            title: '请核对收货信息填写是否正确？',
            confirmButtonClass: 'confirm-btn-class',
            cancelButtonText: '去修改'
          })
            .then(action => {
              createOrder()
            })
            .catch(action => {
              // 修改地址
              const orderId = this.$route.params.id
              this.$router.push({
                name: 'addressList',
                query: { orderId }
              })
            })
        } else {
          createOrder()
        }
      },
      2000,
      { leading: true }
    ),
    before_createOrder() {
      let message = null
      if (this.preOrder.isNeedAddress) {
        if (this.address.id == null) {
          message = '请设置实物地址'
        }
      }
      const paymethod = this.$refs.cardPaymethod
      if (paymethod && paymethod.selectedPaymethod() === false) {
        message = '请选择分期方式'
      }
      if (appUser.isBrowser) {
        // message = '请在微信上支付'
      }
      // 2022年06月15日新增积分支付逻辑
      if (this.fromIntegral) {
        this.$store.commit('payment/order/setdiscountIntegralReal', this.goods.creditVal)
      }
      // end
      if (message) {
        Toast({ message, position: 'bottom' })
      }
      return message == null
    },
    payOrder(order) {
      console.log('order', order)
      // 微信支付或友邻分期（并设置原生支付回调）
      // this.$store.commit('payment/order/setPopShow', true)
      localStorage.setItem('showConfirm', true)
      this.$store.commit('payment/order/setOrder', order)
      const result = Pay(order)
      const toViewHash = '/confirm-order/' + this.goodsId + '?paytype=goods'
      localStorage.setItem('toViewHash', toViewHash)
      order.goodsId = this.goodsId
      this.$store.commit('payment/order/setCurrentOrder', order)
      if (result != null) {
        result.then(({ status }) => {
          // 查询订单需要商品ID
          order.goodsId = this.goodsId
          this.payOrderResult(order, { status })
        })
      }
    },
    // 获取默认地址
    getAddress() {
      if (this.address.id) return
      this.$store.dispatch('payment/address/getDefault')
    },
    // 查询支付结果（用户退出没有回调，则需要特殊处理）
    payOrderResult(order, { status }) {
      // 解决 Safari浏览器中的问题
      let orders = JSON.parse(localStorage.getItem('USER-PAYMENT_ORDER') || '{}')
      if (orders.order) order = orders.order
      console.log(status, order, '----------0000')
      if (status === 'success') {
        // 标记订单状态
        order.isVipForever = this.isVipForever
        order.isVipForeverIncrease = this.isVipForeverIncrease
        order.isIncrease = this.isIncrease
        // 服务器订单状态
        this.$store.dispatch('payment/order/getPayStatusTime', order).then(data => {
          console.log('支付成功----------', data)
          const { status: payStatus } = data
          // payStatus = 1 // 测试为成功
          console.log(payStatus, '-----0000')
          if (this.successStatus(payStatus)) {
            if (this.$route.query.transferType === 'album')
              saTrack('h5_courseunlock_opbuy_click', {
                courseunlock_op_result: '成功'
              })
            console.log('支付结果', payStatus, 'data', data)
            this.routeSuccess(data)
          } else {
            console.log('支付失败')
            Toast({ message: '订单正在处理，请稍后查询', position: 'bottom' })
          }
        })
      } else if (status === 'cancel') {
        this.$store.dispatch('payment/order/cancelOrder', order)
        Toast({ message: '用户取消支付~', position: 'bottom' })
      } else {
        // 服务器订单状态
        this.$store.commit('payment/order/setPayStatus', { status: -1 })
        // this.$refs.payAlert.reset()
        // this.$router.replace({ name: status, params })
        this.$store.dispatch('payment/order/cancelOrder', order)
        Toast({ message: '订单支付失败~', position: 'bottom' })
      }
    },
    // 跳转成功页面
    routeSuccess(data) {
      const { goodsId } = this
      const params = { id: goodsId }
      console.log('准备跳转成功页面', params)
      let name = 'success'
      // 训练营/体验营 的成功页面
      const { campNo, userSno, startDate, adviserCode, iconUrl, adviserName, adviserUrl } = data || {}
      // if (campNo) {
      //   const userId = appUser.userId + ''
      //   const bool = userId.substr(userId.length - 1, 1) < 5
      //   console.log('当前-userId---', userId, '是否0-4------------', bool)
      //   name = 'campSuccess'
      //   if (bool) name = 'newCampSuccess'
      //   const campDate = Date.getUTCDate(startDate, {
      //     format: 'yyyy年MM月dd日'
      //   })
      //   this.$store.commit('payment/order/setPayStatus', {
      //     goodsId,
      //     campNo,
      //     userSno,
      //     campDate,
      //     iconUrl,
      //     adviserName,
      //     adviserUrl,
      //     adviserCode
      //   })
      // }
      // 家庭卡购买成功
      if (this.isSubvipGoods) {
        name = 'subVip-paySuccess'
      }
      this.$router.replace({ name, params })
    },
    agree(value) {
      console.log('value', value)
      this.agreeData = value
    }
  }
}
</script>

<style lang="scss">
.message-address {
  text-align: left;
}
</style>
<style lang="scss" scoped>
.tip_box {
  color: #000;
  padding: 0 0.48rem;
  .tip_name {
    font-size: 0.24rem;
    line-height: 0.4rem;
  }
}

.confirm-order {
  padding-bottom: 2rem;
  // 付款按钮
  .form-bottom-button.form-bottom-label {
    background-color: #fff;
    border-top: 1px solid #f2f2f2;
    .pay-price {
      font-weight: bold;
      font-size: 0.4rem;
      line-height: 0.54rem;
      color: #00b25a;
      text-align: left;
    }
    .pay-price-integral {
    }
  }
  .user_info {
    font-size: 18px;
    padding: 5px;
    text-align: left;
    overflow: hidden;
  }
}
.hasUser {
  padding-bottom: 3.2rem;
}
.integral_pay_info_box {
  justify-content: space-between;
  padding: 0.56rem 0.48rem 0;
  font-size: 0.32rem;
  font-weight: 400;
  color: #000000;
  .pay_num_box {
    font-size: 0.36rem;
    font-weight: 600;
    color: #000000;
  }
}
</style>
